module.exports = __webpack_public_path__ + "static/media/google-store.6b34bd52.png";